var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['post', {
        highlight: _vm.post.highlight
    }]},[_c('div',{staticClass:"content"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.post.name)}}),_c('div',{staticClass:"baseline",domProps:{"innerHTML":_vm._s(_vm.post.baseline)}})]),(_vm.post.layout && _vm.post.layout.length > 0)?_c('router-link',{attrs:{"to":_vm.$trl({
            name: 'Method',
            params: {
                slug: _vm.post.customslug || _vm.post.slug,
                locale: _vm.$route.params.locale,
                technique: _vm.technique
            }
        })}},[_c('IconPlus'),_vm._v(" "+_vm._s(_vm.$t('cta.showmore'))+"\n    ")],1):(_vm.post.image || _vm.post.description || _vm.post.pictogram)?_c('a',{on:{"click":function($event){return _vm.openPopin(_vm.post)}}},[_c('IconPlus'),_vm._v(" "+_vm._s(_vm.$t('cta.showmore'))+"\n    ")],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }